import React, { useContext, useEffect, useState, useRef } from "react";
import Application from "../../../StateContext/Application.js";
import { apiurl } from "../../../../../path.js";
import { useLocation, useNavigate } from "react-router-dom";
import "./DemandGenral.css";

import {
  DemandGenerationblue,
  AddDeduction32,
  AddFile32,
  VendorName32,
  Bank32,
  barely_black_bg_img,
  Cancel32,
  Email32,
  Location32,
  PhoneNumber32,
  submit,
} from "../../../../../public/LoginImages/importimages";
import Select from "react-select";


// 28-10 for UI
const PlusCircle = () => (
  <svg width="16" height="16" viewBox="0 0 24 24">
    <circle cx="12" cy="12" r="11" fill="#fff" />
    <path d="M12 7v10M7 12h10" stroke="#0e2f5a" strokeWidth="2.5" strokeLinecap="round" />
  </svg>
);

const XCircle = ({ bg = "#1a6fc4", fg = "#fff" }) => (
  <svg width="16" height="16" viewBox="0 0 24 24">
    <circle cx="12" cy="12" r="11" fill={bg} stroke={fg} strokeWidth="1.5" />
    <path d="M8.5 8.5l7 7M15.5 8.5l-7 7" stroke={fg} strokeWidth="2.3" strokeLinecap="round" />
  </svg>
);

const CheckCircle = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
    <circle cx="12" cy="12" r="10.5" stroke="#fff" strokeWidth="1.8" />
    <path d="M7.5 12.5l3 3 6-6.5" stroke="#fff" strokeWidth="2.3" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
const DemandGeneration = ({ isEdit, billData, onSuccess, onCancel }) => {
  const navigate = useNavigate();
  const formdataref = useRef(null);
  const operation = useContext(Application);
  const {
    GetProjectInfo,
    GetBudgetHeadInfo,
    DemandCreation,
    BankMaster,
    getTaxes,
    DeductionOperation,
  } = operation;
  const [projectId, setProjectId] = useState([]);
  const [AllData, setALLData] = useState([]);
  const [HeadId, setHeadID] = useState([]);
  const [workID, setWorkID] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [filterWorkOrder, setFilterWorkOrder] = useState([]);
  const [bankData, setBankData] = useState([]);
  const [Taxes, setTaxes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [gst, setGst] = useState(0);
  const [tds, setTds] = useState(0);
  const [security, SetSecurity] = useState(0);
  const [totalpaid, SetTotalPaid] = useState(0);
  const [GrossAmount, setGrossAmount] = useState(0);
  const [netPayableAmount, setNetPayableAmount] = useState(0);
  const [TotalEstimateAmount, setTotalEstimateAmount] = useState(0);
  const [deductionAmount, setDeductionAmount] = useState(0);
  const [deductionList, setDeductionList] = useState([]);
  const [filterdWorkID, setFilteredWorkID] = useState([]);
  const [selectedFavouring, setSelectedFavouring] = useState("");

  const [deductionPercent, setDeductionPercent] = useState("");
  const [selectedDeductionName, setSelectedDeductionName] = useState("");
  const [selectedDeductionID, setSelectedDeductionID] = useState("");
  const [totalDeductionPercent, setTotalDeductionPercent] = useState(0);
  const [totalDeductionAmount, setTotalDeductionAmount] = useState(0);

  const [fetchDeductionData, setFetchDeductionData] = useState([]);
  const [editAmount, setEditAmount] = useState("");
  const [allHeads, setAllHeads] = useState([]); // all budget heads
  const [projectsByHead, setProjectsByHead] = useState([]); // projects for selected head
  const [workOrdersByProject, setWorkOrdersByProject] = useState([]); // work orders
  const [editBillData, setEditBillData] = useState();
  const [showEditForm, setShowEditForm] = useState();
  const [IsEdit, setIsEdit] = useState(null);
  const [EditBillId, setEditBillId] = useState(null);
  const [BillCopy, setBillCopy] = useState(null);
 
      const [errors, setErrors] = useState({}); //23-10
  const [data, setData] = useState({
    ProjectName: "",
    ProjectID: "",
    BudgetHeadID: "",
    BudgetHeadName: "",
    HeadName: "",
    WorkUID: "",
    WorkName: "",
    ContractorName: "",
    BillAmount: "",
    RABillAmount: "",
    Remark: "",
    Account_Number: "",
    CopyofWorkOrder: "",
    WorkOrderUnique: "",
    type: "false",
    piu: "",
    Scheme: "",
    PhysicalProgress: "",
  });
  // console.log("data", data);

  // const HandleChangeData = (e) => {
  //   const { name, value } = e.target;
  //   if (name === "BillAmount") {
  //     console.log("totalEstimationn", TotalEstimateAmount);
  //     console.log("tableDataaa", tableData);

  //     const remaining = tableData?.[0]?.RemainingAmount || 0;
  //     console.log("remainingg", remaining);
  //     const EsitmatationAmount = TotalEstimateAmount || 0;
  //     const numericValue = parseFloat(value);

  //     if (numericValue <= 0) {
  //       alert("Bill amount cannot be negative or zero!");
  //       setData({ ...data, [name]: "" });
  //       return;
  //     }

  //     if (numericValue > parseFloat(remaining)) {
  //       alert("Bill amount cannot exceed remaining amount!");
  //       setData({ ...data, [name]: remaining });
  //       return;
  //     }

  //     // if (numericValue > parseFloat(EsitmatationAmount)) {
  //     //     alert("Bill amount cannot exceed Estimate amount!");
  //     //     setData({ ...data, [name]: EsitmatationAmount });
  //     //     return;
  //     // }
  //   }
  //   setData({ ...data, [name]: value });
  // };

  const HandleChangeData = (e) => {
    const { name, value } = e.target;

    if (name === "BillAmount") {
      console.log("totalEstimationn", TotalEstimateAmount);
      console.log("tableDataaa", tableData);

      const approvedWorkAmount =
        parseFloat(tableData?.[0]?.ApprovedWorkAmount) || 0;

      const numericValue = parseFloat(value);

      console.log("Approved Work Amount:", approvedWorkAmount);
      console.log("Bill Amount:", numericValue);


// 07-10 
 const remainingAmount = parseFloat(tableData?.[0]?.RemainingAmount) || 0;
 console.log("Remaining Amount:", remainingAmount);
if (remainingAmount <= 0) {
  alert("Remaining Amount is not available. Demand Generation cannot be created.");
  setData((prev) => ({
    ...prev,
    BillAmount: "",
  }));
  return;
}
if (numericValue > remainingAmount) {
  alert(
    `Bill Amount cannot exceed Remaining Amount (₹${remainingAmount}).`
  );
  setData((prev) => ({
    ...prev,
    BillAmount: "",
  }));
  return;
}
// // ----



      if (numericValue <= 0) {
        alert("Bill amount cannot be negative or zero!");
        setData({ ...data, [name]: "" });
        return;
      }

      if (numericValue > approvedWorkAmount) {
        alert("Bill amount cannot exceed Approved Work Amount!");
        setData({ ...data, [name]: approvedWorkAmount });
        return;
      }
    }

    setData({ ...data, [name]: value });
  };
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const getbudget = async () => {
    let data = await BankMaster("get");
    console.log("data", data);
    if (data && Array.isArray(data)) {
      setBankData(data);
    } else {
      setBankData([]);
      console.error("Error: Data is not an array or undefined.");
    }
  };

  const GetTaxes = async () => {
    let data = await getTaxes();
    console.log(data);
    setTaxes(data);
  };
  // Fetching
  const handleSubmit = async (e) => {
    e.preventDefault();


    // 23-10
     const validationErrors = {};
    if (!data.ProjectID) {
      validationErrors.ProjectID = "Please select Project Name.";
    }
    if (!data.WorkUID) {
      validationErrors.WorkUID = "Please select Work Order UID.";
    }
    if (!String(data.BillAmount ?? "").trim() ||
      Number(data.BillAmount) <= 0) {
      validationErrors.BillAmount = "Please enter a valid Bill Amount.";
    }
    if (!data.RABillAmount) {
      validationErrors.RABillAmount = "Please select Bill Number.";
    }
    if (!data.Remark?.trim()) {
      validationErrors.Remark = "Please enter Remark.";
    }
    const billCopyFile = document.getElementById("BillCopy")?.files?.[0];
    if (!billCopyFile && !isEdit) {
      validationErrors.BillCopy = "Please upload Bill Copy.";
    }
    setErrors(validationErrors);
    if (Object.keys(validationErrors).length > 0) {
      return;
    }
    if (loading) return;
    setLoading(true);
// 21-09
  // Prevent multiple clicks
  if (loading) return;

  // Start button loader
  setLoading(true);

    const formData = new FormData();

    try {
      console.log("Gross amount:", data.BillAmount);
      console.log("Vendor sending:", data.ContractorName);
      const totalBillAmount = parseFloat(data.BillAmount) || 0;
      if (
        data.ProjectID === "" &&
        data.BudgetHeadID === "" &&
        data.WorkUID === ""
      ) {
        return alert(
          "You have not selected Project or Budget Head or Work ID !!!!!",
        );
      }
      const updatedData = {
        ...data,
        BillAmount: totalBillAmount,
        totalTax: totalDeductionAmount,
        TotalAmountPayToVendor: netPayableAmount,
        piu: data.piu,
      };
      // Append form data
      for (const key in updatedData) {
        formData.append(key, updatedData[key] ?? "");
       
      }
    //  30-10 
        formData.append(
  "DeductionList",
  JSON.stringify(data.type === "true" ? deductionList : []),
);
      const billCopyInput = document.getElementById("BillCopy");
      const billCopyFile = billCopyInput?.files?.[0];

      if (!billCopyFile && !isEdit) {
        alert("Please upload Bill Copy.");
        return;
      }

      if (billCopyFile) {
        formData.append("BillCopy", billCopyFile);
      }
      if (
        data.PhysicalProgress === "" ||
        data.PhysicalProgress === null ||
        data.PhysicalProgress === undefined
      ) {
        alert("Please create physical progress");
        return;
      }

      let result;
      if (isEdit) {
        formData.append("DemandGenerationID", billData.DemandGenerationID);
        formData.append("typeData", "updateDemandData");
      } else {
        formData.append("typeData", "createDemandData");
      }

      // Check form data before API call
      for (let pair of formData.entries()) {
        console.log(pair[0], pair[1]);
      }

      // Call API for both create and update
      result = await DemandCreation(formData);

      console.log("API Result:", result);

      if (result?.message) {
        alert(result.message);
        window.location.reload();
      }
    } catch (error) {
      console.error("Submit Error:", error);
      alert("Something went wrong while submitting data");
    }
  };
  const FetchData = async () => {
    setLoading(true);
    try {
      let res = await GetProjectInfo("null", "WorkOrderProjects");//29-09 agnecy wise project fethciing 
      // let res1 = await GetBudgetHeadInfo('null', "all");
      setProjectId(res);
      // setHeadID(res1);
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };
  const FetchHeads = async () => {
    try {
      let heads = await GetBudgetHeadInfo("null", "all");
      setAllHeads(heads);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    FetchData();
    FetchHeads();
    getbudget();
    GetTaxes();
    FetchInitalData();
  }, []);

  /** ─── Dropdown handlers ─── */
  //Commented on 22june for budgethead
  // const handleHeadSelect = async (headID) => {
  //     setData((prev) => ({
  //         ...prev,
  //         BudgetHeadID: headID,
  //         ProjectID: "", // reset
  //         WorkUID: ""
  //     }));
  //     setWorkOrdersByProject([]); // reset work orders
  //     setTableData([]);
  //     setTotalEstimateAmount(0);

  //     // Fetch projects for this head
  //     try {
  //         let projects = await GetProjectInfo(headID, "DemandGenerationByHead");
  //         // backend should filter by headID
  //         setProjectsByHead(projects || []);
  //     } catch (err) {
  //         console.error(err);
  //     }
  // };

  const handleHeadSelect = async (headID) => {
    setData((prev) => ({
      ...prev,
      BudgetHeadID: headID,
    }));
    setWorkOrdersByProject([]); // reset work orders
    setTableData([]);
    setTotalEstimateAmount(0);
  };
  //commented on 22june for budgethead
  //     const handleProjectSelect = async (projectID) => {
  //         setData((prev) => ({
  //             ...prev,
  //             ProjectID: projectID,
  //             ProjectName: projectsByHead.find(p => p.ProjectId === projectID)?.ProjectName || "",
  //             WorkUID: ""
  //         }));

  //         // ✅ Call backend with type "DemandGeneration"
  //         let projectData = await GetProjectInfo(projectID, "DemandGeneration");
  //         console.log("harshproject", projectData); // should include workorder fields now

  //         setALLData(projectData);

  //         // Deduplicate work orders by WorkOrderID
  //        try {
  //         // Get project details with work orders
  //         let projectData = await GetProjectInfo(projectID, "DemandGeneration");
  //         console.log("Project Data with Work Orders:", projectData);

  //         setALLData(projectData);

  //         // Filter and map work orders
  //          let workOrders = projectData
  //             .filter(item => item.WorkOrderNo) // only items with work order numbers
  //             .map(item => {
  //                 const approved = parseFloat(item.ApprovedWorkAmount || item.ApprovedAmount || 0);
  //                 const paid = parseFloat(item.PaidAmount || item.AmountPaid || 0);
  //                 const remaining = typeof item.RemainingAmount !== "undefined"
  //                     ? parseFloat(item.RemainingAmount)
  //                     : (approved - paid);

  //                  return {
  //                         workNo: item.WorkOrderNo,
  //                         workOrderID: item.WorkOrderID,
  //                         WorkName: item.WorkName,
  //                         ContractorName: item.ContractorName,
  //                         BudgetHead: item.HeadName || item.BudgetHead,
  //                         Account_Number: item.Account_Number,
  //                         BANK_NAME: item.BANK_NAME,
  //                         IFSC_CODE: item.IFSC_CODE,
  //                         BranchName: item.BranchName,
  //                         CopyofWorkOrder: item.CopyofWorkOrder,
  //                         FinancialYear: item.FinancialYear,
  //                         Date: item.Date,
  //                         ApprovedWorkAmount: approved,
  //                         PaidAmount: paid,
  //                         RemainingAmount: remaining
  //                     };
  //             });

  //         // Remove duplicates
  //         workOrders = Array.from(new Map(workOrders.map(item =>
  //             [item.workOrderID || item.workNo, item]
  //         )).values());

  //         console.log("Filtered Work Orders:", workOrders);
  //         setWorkOrdersByProject(workOrders);

  //     } catch (err) {
  //         console.error("Error fetching project data:", err);
  //         setWorkOrdersByProject([]);
  //     }
  // };
  const handleProjectSelect = async (projectID) => {
    try {
      // First fetch project data
      let projectData = await GetProjectInfo(projectID, "DemandGeneration");

      console.log("Project Data with Work Orders:", projectData);

      setALLData(projectData);

      // Then update state
      setData((prev) => ({
        ...prev,
        ProjectID: projectID,
        ProjectName: projectData?.[0]?.ProjectName || "",
        BudgetHeadID: projectData?.[0]?.HeadID || "",
        BudgetHeadName: projectData?.[0]?.HeadName || "",
        piu: projectData?.[0]?.PIU || "",
        Scheme: projectData?.[0]?.Scheme || "",
        WorkUID: "",
      }));

      let workOrders = projectData
        .filter((item) => item.WorkOrderNo)
        .map((item) => {
          const approved = parseFloat(
            item.ApprovedWorkAmount || item.ApprovedAmount || 0,
          );

          const paid = parseFloat(item.PaidAmount || item.AmountPaid || 0);

          const remaining =
            typeof item.RemainingAmount !== "undefined"
              ? parseFloat(item.RemainingAmount)
              : approved - paid;

          return {
            workNo: item.WorkOrderNo,
            workOrderID: item.WorkOrderID,
            WorkName: item.WorkName,
            ContractorName: item.ContractorName,
            BudgetHead: item.HeadName || item.BudgetHead,
            Account_Number: item.Account_Number,
            BANK_NAME: item.BANK_NAME,
            IFSC_CODE: item.IFSC_CODE,
            BranchName: item.BranchName,
            CopyofWorkOrder: item.CopyofWorkOrder,
            FinancialYear: item.FinancialYear,
            Date: item.Date,
            PhysicalProgress: item.PhysicalProgress,
            ApprovedWorkAmount: approved,
            PaidAmount: paid,
            RemainingAmount: remaining,
          };
        });

      workOrders = Array.from(
        new Map(
          workOrders.map((item) => [item.workOrderID || item.workNo, item]),
        ).values(),
      );

      setWorkOrdersByProject(workOrders);

      if (isEdit && billData) {
        const selectedWork = workOrders.find(
          (item) => String(item.workOrderID) === String(billData.WorkUniqueID),
        );
        console.log("Selected Work:", selectedWork);
        if (selectedWork) {
          handleWorkOrderSelect(selectedWork.workOrderID);
          setTableData([selectedWork]);
          setData((prev) => ({
            ...prev,
            // WorkUID: selectedWork.workOrderID,
            WorkUID: selectedWork ? selectedWork.workNo : "",
            WorkOrderUnique: selectedWork.workOrderID,
            WorkName: selectedWork.WorkName,
            ContractorName: selectedWork.ContractorName,
            Account_Number: selectedWork.Account_Number,
            CopyofWorkOrder: selectedWork.CopyofWorkOrder,
            PhysicalProgress: selectedWork.PhysicalProgress,
          }));
          setTableData([selectedWork]);
        }
      }
    } catch (err) {
      console.error("Error fetching project data:", err);
      setWorkOrdersByProject([]);
    }
  };

  const HeadIDFetchOperation = async (ID, IDtype) => {
    try {
      console.log(ID);
      if (IDtype === "ProjectId") {
        let res1 = await GetProjectInfo(ID, "DemandGeneration");
        console.log("Project ID info :: ", res1);

        if (res1 && res1.length > 0) {
          let projectData = res1[0];
          console.log("projectData", projectData);
          setALLData(res1);

          setData((prev) => ({
            ...prev,
            ProjectName: projectData?.ProjectName || "",
            ProjectID: projectData?.ProjectId || "",
          }));

          let AllheadId = res1.map((item) => ({
            HeadID: item.HeadID,
            HeadName: item.HeadName,
            CRC: item.CRC,
          }));
          setHeadID(AllheadId);
        } else {
          // No data found for this project
          setALLData([]);
          setHeadID([]);
          setData((prev) => ({
            ...prev,
            ProjectName: "",
            ProjectID: ID,
          }));
        }
      }
    } catch (err) {
      console.log(err);
    }
  };
  // console.log("Alldata", tableData);

  // const PaymentAmountTable = () => {
  //     const { ProjectID, BudgetHeadID, WorkUID } = data;
  //     // console.log(ProjectID, BudgetHeadID, WorkUID);

  //     if (!ProjectID || !BudgetHeadID || !WorkUID) {
  //         alert("You Not have selected all three fileds !!! Select it ");
  //         return;
  //     }
  //     let result = AllData?.filter((item) => {
  //         return item.ProjectID == ProjectID && item.HeadID == BudgetHeadID && item.UniqueID == WorkUID
  //     });
  //     // console.log("result", result)
  //     let details = result[0];

  //     setData((prev) => ({
  //         ...prev,
  //         ContractorName: details?.ContractorName,
  //         WorkName: details?.WorKName,
  //         BudgetHeadName: details?.BudgetHead,
  //         CopyofWorkOrder: details?.CopyofWorkOrder,
  //         WorkOrderUnique: details?.WorkOrderID
  //     }));
  //     setTableData(result);
  // }

  const FetchInitalData = async () => {
    try {
      let res = await DeductionOperation("null", "fetchalldatafromBank");
      console.log("result :: ", res);
      setFetchDeductionData(res);
    } catch (err) {
      console.log(err);
    }
  };

  // useEffect(() => {
  //     FetchInitalData();
  //     FetchData()
  //     getbudget()
  //     GetTaxes()
  // }, [])

  // useEffect(() => {
  //     if (data.ProjectID && data.BudgetHeadID && data.WorkUID) {
  //         PaymentAmountTable();
  //     }
  // }, [data.ProjectID, data.BudgetHeadID, data.WorkUID]);

  useEffect(() => {
    console.log("data.billamount", data.BillAmount);
    if (data.BillAmount) {
      console.log("data.billamount", data.BillAmount);

      const totalPayment = Number(data.BillAmount);
      const calculatedGst = Math.ceil((totalPayment * 18) / 100);
      const calculatedTds = Math.ceil((totalPayment * 12) / 100);
      const calculatedSecurity = Math.ceil((totalPayment * 2) / 100);
      const totalTax = calculatedGst + calculatedTds + calculatedSecurity;
      const calculatedTotalPaid = totalPayment - totalTax;

      setGst(calculatedGst);
      setTds(calculatedTds);
      SetSecurity(calculatedSecurity);
      SetTotalPaid(calculatedTotalPaid);

      setData((prev) => ({
        ...prev,
        SGST: calculatedGst,
        CGST: calculatedTds,
        SecurityDeposite: calculatedSecurity,
        totalTax: totalTax,
        TotalAmountPayToVendor: netPayableAmount,
      }));
    }
  }, [data.BillAmount]);

  const uniqueHeads = [];
  const filteredData = HeadId.filter((item) => {
    const isDuplicate = uniqueHeads.includes(item.HeadName);
    if (!isDuplicate) {
      uniqueHeads.push(item.HeadName);
      return true;
    }
    return false;
  });

  const uniqueWorkOrder = [];

  const filteredWorkOrderData = workID.filter((item) => {
    const isDuplicate = uniqueWorkOrder.includes(item.workNo);
    if (!isDuplicate) {
      uniqueWorkOrder.push(item.workNo);
      return true;
    }
    return false;
  });

  // useEffect(() => {
  //   // setGrossAmount((parseFloat(data.BillAmount) + parseFloat(data.BillAmount) * 0.18));
  //   setGrossAmount(parseFloat(data.BillAmount));

  //   setNetPayableAmount(
  //     parseFloat(GrossAmount) - parseFloat(totalDeductionAmount),
  //   );
  // }, [data.BillAmount, GrossAmount, totalDeductionAmount]);

  useEffect(() => {
    const billAmount = parseFloat(data.BillAmount) || 0;
    const deduction = parseFloat(totalDeductionAmount) || 0;

    setGrossAmount(billAmount);

    setNetPayableAmount(Number((billAmount - deduction).toFixed(2)));
  }, [data.BillAmount, totalDeductionAmount]);
  // const GetBugdetEstimationAmount = async (bID, PID) => {
  //     try {
  //         let obj = {
  //             PID: PID,
  //             BID: bID
  //         }
  //         let res = await GetProjectInfo(obj, "getprojectbugetEstimation");
  //         console.log("budget estimation res", res);
  //           if (res && res.length > 0) {
  //   setTotalEstimateAmount(
  //     res[0].EstimateAmountAfterBill ?? res[0].EsitmateAmount ?? 0
  //   );
  // } else {
  //   setTotalEstimateAmount(0);
  // }
  //         // setTotalEstimateAmount(res[0].TotalEstimateAmount);
  //         //setTotalEstimateAmount(res[0].EstimateAmountAfterBill);

  //     }
  //     catch (err) {
  //         console.log(err);
  //     }
  // }
  const GetBugdetEstimationAmount = async (bID, PID) => {
    try {
      let obj = { PID: PID, BID: bID };
      let res = await GetProjectInfo(obj, "getprojectbugetEstimation");
      console.log("budget estimation res", res);

      if (res && res.length > 0) {
        let afterBill = parseFloat(res[0].EstimateAmountAfterBill);
        let estimate = parseFloat(res[0].EsitmateAmount);

        // fallback logic
        if (isNaN(afterBill) || afterBill <= 0) {
          setTotalEstimateAmount(estimate || 0);
        } else {
          setTotalEstimateAmount(afterBill);
        }
      } else {
        setTotalEstimateAmount(0);
      }
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    if (data.BudgetHeadID && data.ProjectID) {
      GetBugdetEstimationAmount(data.BudgetHeadID, data.ProjectID);
    } else {
      console.log("MIssing parameter head or project ID");
    }
  }, [data.BudgetHeadID, data.ProjectID]);

  // useEffect(() => {
  //     if (tableData.length > 0 && data.BillAmount !== "") {
  //         const bill = parseFloat(data.BillAmount);
  //         const remaining = parseFloat(tableData[0].RemainingAmount);
  //         console.log("Bill ", bill, "Reaming in", remaining);

  //         if (bill > remaining || bill < 0) {
  //             setData(prev => ({ ...prev, BillAmount: "" }));
  //         }
  //     }
  // }, [data.BillAmount, tableData]);

  // new code for deduction amount

  // const deductionOperation = (e) => {
  //     e.preventDefault();

  //     if (data && data.BillAmount) {
  //         const percent = parseFloat(0);
  //         const netAmount = parseFloat(data.BillAmount);

  //         const deductionAmount = ((percent / 100) * netAmount).toFixed(2);

  //         let d = {
  //             ProjectID: data.ProjectID,
  //             HeadID: data.BudgetHeadID,
  //             WorkUniqueID: data.WorkUID,
  //             DeductionAmount: deductionAmount,
  //             DeductionPercent: percent,
  //             DeductionName: selectedDeductionName,
  //             DeductionID: selectedDeductionID
  //         };

  //         const isDuplicate = deductionList.some(item => item.DeductionID === selectedDeductionID);

  //         if (isDuplicate) {
  //             alert('Deduction with this percentage already exists.');
  //             return;
  //         }

  //         const updatedDeductionList = [...deductionList, d];
  //         setDeductionList(updatedDeductionList);
  //         setDeductionPercent("");

  //         // Total deduction
  //         const totalDeductionPercent = updatedDeductionList.reduce((total, deduction) => total + parseFloat(deduction.DeductionPercent), 0);
  //         const totalDeductionAmount = updatedDeductionList.reduce((total, deduction) => total + parseFloat(deduction.DeductionAmount), 0);

  //         setTotalDeductionPercent(totalDeductionPercent);
  //         setTotalDeductionAmount(totalDeductionAmount);
  //     }
  //     else {
  //         return alert("Enter Net Amount or Deduction Percentage !!!");
  //     }
  // };

  const deductionOperation = ({ DeductionID, DeductionName }) => {
    // e.preventDefault();
    console.log(DeductionID, DeductionName);

    if (!(data && data.BillAmount)) {
      return alert("Enter Net Amount or Deduction Percentage !!!");
    }

    const percent = parseFloat(0); // default 0 at start
    const netAmount = parseFloat(data.BillAmount);
    const deductionAmount = ((percent / 100) * netAmount).toFixed(2);

    let d = {
      ProjectID: data.ProjectID,
      HeadID: data.BudgetHeadID,
      WorkUniqueID: data.WorkUID,
      DeductionAmount: deductionAmount,
      DeductionPercent: percent,
      DeductionName: DeductionName,
      DeductionID: DeductionID,
      piu: data.piu,
    };

    const isDuplicate = deductionList.some(
      (item) => item.DeductionID === DeductionID,
    );

    if (isDuplicate) {
      alert("Deduction with this percentage already exists.");
      return;
    }

    // instead of adding to list, show edit form
    console.log(d);

    setEditIndex(d);
    setEditIndexOF(deductionList.length); // position where it will be inserted
  };

  // const handleDeleteDeduction = (e, id) => {
  //   e.preventDefault();
  //   const updatedList = deductionList.filter((d) => d.DeductionID !== id);

  //   setDeductionList(updatedList);

  //   // Recalculate totals
  //   const totalPercent = updatedList.reduce(
  //     (sum, d) => sum + parseFloat(d.DeductionPercent),
  //     0,
  //   );
  //   const totalAmount = updatedList.reduce(
  //     (sum, d) => sum + parseFloat(d.DeductionAmount),
  //     0,
  //   );

  //   setTotalDeductionPercent(totalPercent);
  //   setTotalDeductionAmount(totalAmount);
  // };

  // useEffect(() => {
  //   if (data.BillAmount && deductionList.length > 0) {
  //     const netAmount = parseFloat(data.BillAmount);
  //     let totalPercent = 0;
  //     let totalAmount = 0;

  //     const updatedList = deductionList.map((d) => {
  //       const percent = d.DeductionPercent || 0;
  //       const updatedAmount = (percent / 100) * netAmount;
  //       totalPercent += parseFloat(percent);
  //       totalAmount += updatedAmount;

  //       return {
  //         ...d,
  //         DeductionAmount: updatedAmount,
  //       };
  //     });

  //     if (totalPercent > 100) {
  //       alert(
  //         `Total deduction percent (${totalPercent}%) exceeds 100%. Please adjust.`,
  //       );
  //       return;
  //     }

  //     if (totalAmount > netAmount) {
  //       const excess = (totalAmount - netAmount).toFixed(2);
  //       alert(
  //         `Total deduction amount exceeds Bill Amount by ₹${excess}. Please adjust.`,
  //       );
  //       return;
  //     }

  //     const hasInvalid = updatedList.some((d) => d.DeductionAmount > netAmount);
  //     if (hasInvalid) {
  //       alert("One or more deductions exceed the total Bill Amount.");
  //       return;
  //     }

  //     const hasChanged = updatedList.some(
  //       (d, i) => d.DeductionAmount !== deductionList[i].DeductionAmount,
  //     );

  //     if (hasChanged) {
  //       setDeductionList(updatedList);
  //       setTotalDeductionPercent(totalPercent);
  //       setTotalDeductionAmount(totalAmount);
  //     }
  //   }
  // }, [deductionList, data.BillAmount]);

  // change fro deduction calculation on amount
  const handleDeleteDeduction = (e, id) => {
    e.preventDefault();

    const updatedList = deductionList.filter(
      (d) => String(d.DeductionID) !== String(id),
    );

    // Calculate totals safely
    const totalPercent = updatedList.reduce(
      (sum, d) => sum + (parseFloat(d.DeductionPercent) || 0),
      0,
    );

    const totalAmount = updatedList.reduce(
      (sum, d) => sum + (parseFloat(d.DeductionAmount) || 0),
      0,
    );

    setDeductionList(updatedList);
    setTotalDeductionPercent(Number(totalPercent.toFixed(2)));
    setTotalDeductionAmount(Number(totalAmount.toFixed(2)));
  };

  // useEffect(() => {
  //   const billAmount = parseFloat(data.BillAmount) || 0;

  //   if (billAmount <= 0 || deductionList.length === 0) {
  //     setTotalDeductionPercent(0);
  //     setTotalDeductionAmount(0);
  //     return;
  //   }

  //   let totalPercent = 0;
  //   let totalAmount = 0;

  //   const updatedList = deductionList.map((d) => {
  //     // Percentage should remain the entered percentage
  //     const percent = parseFloat(d.DeductionPercent) || 0;

  //     // Calculate amount from Bill Amount
  //     const amount = (billAmount * percent) / 100;

  //     totalPercent += percent;
  //     totalAmount += amount;

  //     return {
  //       ...d,
  //       DeductionPercent: percent,
  //       DeductionAmount: Number(amount.toFixed(2)),
  //     };
  //   });

  //   // Validate total percentage
  //   if (totalPercent > 100) {
  //     alert(
  //       `Total deduction percent (${totalPercent.toFixed(
  //         2
  //       )}%) exceeds 100%. Please adjust.`
  //     );
  //     return;
  //   }

  //   // Validate total amount
  //   if (totalAmount > billAmount) {
  //     const excess = totalAmount - billAmount;

  //     alert(
  //       `Total deduction amount exceeds Bill Amount by ₹${excess.toFixed(2)}.`
  //     );
  //     return;
  //   }

  //   setTotalDeductionPercent(Number(totalPercent.toFixed(2)));
  //   setTotalDeductionAmount(Number(totalAmount.toFixed(2)));

  //   // Only update amounts, don't unnecessarily replace the list
  //   const hasChanged = updatedList.some(
  //     (d, index) =>
  //       Number(d.DeductionAmount) !==
  //       Number(deductionList[index]?.DeductionAmount)
  //   );

  //   if (hasChanged) {
  //     setDeductionList(updatedList);
  //   }
  // }, [data.BillAmount, deductionList]);

  useEffect(() => {
    const billAmount = parseFloat(data.BillAmount) || 0;

    if (billAmount <= 0 || deductionList.length === 0) {
      setTotalDeductionPercent(0);
      setTotalDeductionAmount(0);
      return;
    }

    // Total deduction amount is the main value
    const totalAmount = deductionList.reduce(
      (sum, d) => sum + (parseFloat(d.DeductionAmount) || 0),
      0,
    );

    // Calculate total percentage FROM total amount
    const totalPercent = (totalAmount / billAmount) * 100;

    setTotalDeductionAmount(Number(totalAmount.toFixed(2)));
    setTotalDeductionPercent(Number(totalPercent.toFixed(4)));
  }, [data.BillAmount, deductionList]);
  const changeselectedName = (id) => {
    if (id != "") {
      let res = fetchDeductionData.filter((item) => item.DeductionID == id);
      setSelectedDeductionName(res[0].UseFor);
    }
  };

  const [editIndexOF, setEditIndexOF] = useState(null);

  const [editIndex, setEditIndex] = useState(null);

  useEffect(() => {
    if (editIndex !== null) {
      const netAmount = parseFloat(data.BillAmount || 0);
      const amount = parseFloat(editIndex.DeductionAmount || 0);
      const updatedPercent = ((amount / netAmount) * 100).toFixed(2);
      setEditIndex({ ...editIndex, DeductionPercent: updatedPercent });
    }
  }, [editIndex?.DeductionAmount, data.BillAmount]); //uncomment this part at 9/7/2026

  const handleEdit = (e, index, row) => {
    e.preventDefault();
    const item = deductionList[index];
    console.log("row i selected :: ", item);
    setEditIndex(item);
    setEditIndexOF(index);
    // 30-10
    setSelectedDeductionID(item.DeductionID);
  setSelectedDeductionName(item.DeductionName);
  setSelectedFavouring(item.Favouring || data.ContractorName || "");
    setShowEditForm(true);
  };

  // const handelchangeTablre = (e) => {
  //   e.preventDefault();

  //   // ==============================
  //   // VALIDATION BEFORE ADD
  //   // ==============================

  //   // 1. Validate Favouring
  //   if (!data.ContractorName || data.ContractorName.trim() === "") {
  //     alert("Please select Favouring first.");
  //     return;
  //   }

  //   // 2. Validate Deduction Type
  //   if (!selectedFavouring) {
  //     alert("Please select Favouring first.");
  //     return;
  //   }
  //   if (!selectedDeductionID || selectedDeductionID === "") {
  //     alert("Please select Deduction Type first.");
  //     return;
  //   }

  //   // 3. Validate deduction data
  //   if (!editIndex) {
  //     alert("Please select Deduction Type and enter Deduction Amount.");
  //     return;
  //   }

  //   const deductionAmount = parseFloat(editIndex.DeductionAmount || 0);

  //   if (isNaN(deductionAmount) || deductionAmount <= 0) {
  //     alert("Please enter a valid Deduction Amount.");
  //     return;
  //   }

  //   const netAmount = parseFloat(data.BillAmount || 0);

  //   if (!netAmount || netAmount <= 0) {
  //     alert("Please enter Total Bill Amount first.");
  //     return;
  //   }

  //   let updatedList = [...deductionList];

  //   // const netAmount = parseFloat(data.BillAmount || 0);
  //   // let updatedList = [...deductionList];

  //   if (editIndexOF !== null && updatedList[editIndexOF]) {
  //     // update existing
  //     updatedList[editIndexOF] = editIndex;
  //   } else {
  //     // new insert
  //     updatedList.push(editIndex);
  //   }

  //   const totalDeductionPercent = updatedList.reduce(
  //     (total, d) => total + parseFloat(d.DeductionPercent || 0),
  //     0,
  //   );
  //   const totalDeductionAmount = parseFloat(
  //     updatedList
  //       .reduce((total, d) => total + parseFloat(d.DeductionAmount || 0), 0)
  //       .toFixed(2),
  //   );

  //   if (parseFloat(editIndex.DeductionAmount) > netAmount) {
  //     alert(`Deduction amount cannot exceed the Bill Amount (₹${netAmount}).`);
  //     setEditIndex(null);
  //     setEditIndexOF(null);
  //     return;
  //   }

  //   if (totalDeductionPercent > 100) {
  //     alert(
  //       `Total deduction percent (${totalDeductionPercent}%) exceeds 100%. Please adjust.`,
  //     );
  //     setEditIndex(null);
  //     setEditIndexOF(null);
  //     return;
  //   }

  //   if (totalDeductionAmount > netAmount) {
  //     const excess = (totalDeductionAmount - netAmount).toFixed(2);
  //     alert(
  //       `Total deduction amount exceeds Bill Amount by ₹${excess}. Please adjust.`,
  //     );
  //     setEditIndex(null);
  //     setEditIndexOF(null);
  //     return;
  //   }

  //   setDeductionList(updatedList);
  //   setTotalDeductionPercent(totalDeductionPercent);
  //   setTotalDeductionAmount(totalDeductionAmount);
  //   setEditIndex(null);
  //   setEditIndexOF(null);
  //   setEditAmount("");
  // };

  const handelchangeTablre = (e) => {
    e.preventDefault();

    if (!data.ContractorName || data.ContractorName.trim() === "") {
      alert("Please select Favouring first.");
      return;
    }

    if (!selectedFavouring) {
      alert("Please select Favouring first.");
      return;
    }

    if (!selectedDeductionID) {
      alert("Please select Deduction Type first.");
      return;
    }

    if (!editIndex) {
      alert("Please select Deduction Type and enter Deduction Amount.");
      return;
    }

    const billAmount = parseFloat(data.BillAmount) || 0;
    const deductionAmount = parseFloat(editIndex.DeductionAmount) || 0;

    if (billAmount <= 0) {
      alert("Please enter Total Bill Amount first.");
      return;
    }

    if (deductionAmount <= 0) {
      alert("Please enter a valid Deduction Amount.");
      return;
    }

    if (deductionAmount > billAmount) {
      alert(`Deduction amount cannot exceed the Bill Amount (₹${billAmount}).`);
      return;
    }

    // Calculate percentage FROM amount
 const deductionPercent = Number(((deductionAmount / billAmount) * 100).toFixed(2)); //28-10 for percent ui
    const updatedDeduction = {
      ...editIndex,
      DeductionAmount: deductionAmount,
      DeductionPercent: deductionPercent,
      Favouring:selectedFavouring // 30-10
    };

    let updatedList = [...deductionList];

    if (editIndexOF !== null && updatedList[editIndexOF]) {
      // EDIT
      updatedList[editIndexOF] = updatedDeduction;
    } else {
      // ADD
      updatedList.push(updatedDeduction);
    }

    // Calculate total amount
    const totalAmount = updatedList.reduce(
      (sum, d) => sum + (parseFloat(d.DeductionAmount) || 0),
      0,
    );

    // Calculate total percentage FROM total amount
    const totalPercent = (totalAmount / billAmount) * 100;

    if (totalAmount > billAmount) {
      alert(`Total deduction amount cannot exceed Bill Amount.`);
      return;
    }

    if (totalPercent > 100) {
      alert(`Total deduction percent cannot exceed 100%.`);
      return;
    }

    setDeductionList(updatedList);

    setTotalDeductionAmount(Number(totalAmount.toFixed(2)));

    setTotalDeductionPercent(Number(totalPercent.toFixed(4)));

    setEditIndex(null);
    setEditIndexOF(null);
    setEditAmount("");

    // 28-09 clear deduction form
    setSelectedFavouring("");
setSelectedDeductionID("");
setSelectedDeductionName("");
  };
  // commented for active the cross on dropdown 15-09
  // const handleWorkOrderSelect = (workOrderNo) => {
  //   if (!workOrderNo) return;

  //   const selectedWork = workOrdersByProject.find(
  //     (w) => w.workNo === workOrderNo,
  //   );
  //   if (selectedWork) {
  //     setData((prev) => ({
  //       ...prev,
  //       WorkUID: workOrderNo,
  //       ContractorName: selectedWork.ContractorName,
  //       Account_Number: selectedWork.Account_Number,
  //       WorkName: selectedWork.WorkName,
  //       BudgetHeadName: selectedWork.BudgetHead,
  //       CopyofWorkOrder: selectedWork.CopyofWorkOrder,
  //       WorkOrderUnique: selectedWork.workOrderID,
  //       PhysicalProgress: selectedWork.PhysicalProgress,
  //     }));
  //     setTableData([
  //       {
  //         ...selectedWork,
  //         BANK_NAME: selectedWork.BANK_NAME,
  //         IFSC_CODE: selectedWork.IFSC_CODE,
  //         BranchName: selectedWork.BranchName,
  //       },
  //     ]);
  //   }
  // };
  
   const handleWorkOrderSelect = (workOrderNo) => {
  // Cross icon click hone par clear
  if (!workOrderNo) {
    setData((prev) => ({
      ...prev,
      WorkUID: "",
      ContractorName: "",
      Account_Number: "",
      WorkName: "",
      BudgetHeadName: "",
      CopyofWorkOrder: "",
      WorkOrderUnique: "",
      PhysicalProgress: "",
    }));
 
    setTableData([]);
    return;
  }
 
  const selectedWork = workOrdersByProject.find(
    (w) => w.workNo === workOrderNo,
  );
 
  if (selectedWork) {
    setData((prev) => ({
      ...prev,
      WorkUID: workOrderNo,
      ContractorName: selectedWork.ContractorName,
      Account_Number: selectedWork.Account_Number,
      WorkName: selectedWork.WorkName,
      BudgetHeadName: selectedWork.BudgetHead,
      CopyofWorkOrder: selectedWork.CopyofWorkOrder,
      WorkOrderUnique: selectedWork.workOrderID,
      PhysicalProgress: selectedWork.PhysicalProgress,
    }));
 
    setTableData([
      {
        ...selectedWork,
        BANK_NAME: selectedWork.BANK_NAME,
        IFSC_CODE: selectedWork.IFSC_CODE,
        BranchName: selectedWork.BranchName,
      },
    ]);
  }
};
 
  const handleFile = (e) => {
    const file = e.target.files[0];

    setData({
      ...data,
      UploadBillCopy: file,
    });
  };

  useEffect(() => {
    if (isEdit && billData) {
      console.log("child billData before submit:", billData);
      console.log("DeductionList:", billData.DeductionList);
      setData({
        // DemandGenerationID: billData.DemandGenerationID || "",
        ProjectID: billData.ProjectID || "",
        ProjectName: billData.ProjectName || "",
        BudgetHeadID: billData.BudgetID || "",
        BudgetHeadName: billData.BudgetHead || "",
        WorkUID: billData.WorkOrderUID || billData.WorkUniqueID || "",
        WorkOrderUnique:
          billData.MainWorkOrderID || billData.WorkUniqueID || "",
        WorkName: billData.WorkName || "",
        ContractorName:
          billData.ContractorName || billData.Vendor_Company_Name || "",
        BillAmount: billData.BillAmount || billData.TotalAmount || "",
        RABillAmount: billData.RABillNumber || "",
        Remark: billData.Remark || "",
        Account_Number:
          billData.Account_Number || billData.Bank_Account_Number || "",
        UploadBillCopy: billData.UploadBillCopy || "",
        CopyofWorkOrder: billData.CopyofWorkOrder || "",
        type:    billData.DeductionList && billData.DeductionList.length > 0 ? "true"   : "false",
        piu: billData.PIU || "",
        PhysicalProgress: billData.PhysicalProgress || "",
      });
      handleProjectSelect(billData.ProjectID);

      // if (billData.DeductionList) {
      //   console.log("billData", billData);
      //   console.log("DeductionList", billData.DeductionList);

      //   const deductionData = billData.DeductionList.map((item) => ({
      //     ProjectID: item.ProjectID,
      //     HeadID: item.HeadID,
      //     WorkUniqueID: item.WorkUniqueID,
      //     DeductionAmount: item.Deduction_Amount,
      //     DeductionPercent: item.Deduction_Percent,
      //     DeductionName: item.Deduction_Name,
      //     DeductionID: item.DeductionID,
      //   }));

      //   setDeductionList(deductionData);
      //   setTotalDeductionAmount(
      //     deductionData.reduce(
      //       (sum, item) => sum + Number(item.DeductionAmount || 0),
      //       0,
      //     ),
      //   );
      //   setTotalDeductionPercent(
      //     deductionData.reduce(
      //       (sum, item) => sum + Number(item.DeductionPercent || 0),
      //       0,
      //     ),
      //   );
      // }

// 24-09 ------deuxtion not fetch
      

if (billData.DeductionList) {

  console.log("🔥 CHILD RECEIVED DeductionList:", billData.DeductionList);

  const deductionData = billData.DeductionList.map((item) => ({
    ProjectID: item.ProjectID,
    HeadID: item.HeadID,
    WorkUniqueID: item.WorkUniqueID,

    // ✅ CORRECT PROPERTY NAMES
    DeductionAmount: Number(item.DeductionAmount || 0),
    DeductionPercent: Number(item.DeductionPercent || 0),
    DeductionName: item.DeductionName || "",

    DeductionID: item.DeductionID,
  }));

  console.log("🔥 CHILD MAPPED DEDUCTIONS:", deductionData);

  setDeductionList(deductionData);

  setTotalDeductionAmount(
    deductionData.reduce(
      (sum, item) => sum + Number(item.DeductionAmount || 0),
      0
    )
  );

  setTotalDeductionPercent(
    deductionData.reduce(
      (sum, item) => sum + Number(item.DeductionPercent || 0),
      0
    )
  );
}

// ------------
    }
  }, [isEdit, billData]);
  const resetData = () => {
    // formdataref.current.re
    setData([]);
  };
  console.log("Selected WorkUID:", data.WorkUID);
  console.log("Work Orders:", workOrdersByProject);
  console.log(
    "Match Found:",
    workOrdersByProject.find((w) => String(w.workNo) === String(data.WorkUID)),
  );
  console.log("Selected WorkUID:", data.WorkUID);
  workOrdersByProject.forEach((item) => {
    console.log({
      workNo: item.workNo,
      WorkOrderID: item.WorkOrderID,
      WorkUniqueID: item.WorkUniqueID,
      MainWorkOrderID: item.MainWorkOrderID,
    });
  });
  console.log("First Object:", workOrdersByProject[0]);
// 21-09
<style>
  {`
    @keyframes buttonSpin {
      from {
        transform: rotate(0deg);
      }
      to {
        transform: rotate(360deg);
      }
    }
  `}
</style>
  return (
    <>
      <div
        style={{
          background: "#ffffff",
          width: "auto",
          maxHeight: "90vh",
          // minHeight: '100vh',
          transition: "margin-left 0.3s ease",
          overflowY: "auto",
          msOverflowStyle: "none", // IE & Edge
          scrollbarWidth: "none",
          padding: 20,
          fontFamily: "Inter, sans-serif",
        }}
      >
        <div className="col-12 ">
            {/* 28-10 */}
<div className="dg-header">
  <div className="dg-title">
    <img src={"/Demand-Generation-32_blue.png"} alt="" />
    <h3>Bill Generation</h3>
  </div>
{/*30-10 */}
{isEdit && (
  <button
    type="button"
    className="dg-back"
    onClick={() => {
      if (onCancel) {
        onCancel();  
      } else {
        navigate(-1);  
      }
    }}
  >
    ← Back
  </button>
)}
</div>

          <div className="col-12 m-auto my-5 budgetContainer">
            <div className="m-auto DemandElement" >
              {loading && <div className="loader" ></div>}
              <form className="dg-panel" action="" >
                {/* <div className="col-12 elements">
                                    <div className="row">
                                        <div className="col-3 my-auto ">
                                            <label className='my-auto' style={{ fontWeight: '700' }} >Budget Head</label>
                                        </div>
                                        <div className="col-9">
                                            {/* <select name="ProjectID" value={data.ProjectID} id="" className='py-2' onChange={(e) => { HandleChangeData(e); HeadIDFetchOperation(e.target.value, "ProjectId") }}>
                                                < option>Choose Project</option>
                                                {projectId && projectId.map((val, index) => {
                                                    return (
                                                        <option key={index} value={val.ProjectId}>{val.ProjectName}</option>
                                                    )
                                                })
                                                }
                                            </select> 
                                            {/* 1. Head Dropdown 
                                            <select
                                                name="BudgetHeadID"
                                                value={data.BudgetHeadID}
                                                style={{ height: '33px' }}
                                                onChange={(e) => handleHeadSelect(e.target.value)}
                                            >
                                                <option value="">Choose Budget Head</option>
                                                {allHeads.map((val, index) => (
                                                    <option key={index} value={val.HeadID}>
                                                        {val.CRC}/{val.HeadName}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                </div> */}

                <div className="col-12 elements">
                  <div className="row">
                    <div className="col-3  ">
                      <label style={{ fontWeight: "700",fontSize: "14px",fontWeight:"700", }}>Project Name</label>
                    </div>
                    <div className="col-9">
                           <Select
                        placeholder="Choose Project"
                        value={
                          data.ProjectID
                            ? {
                                value: data.ProjectID,
                              label:
  projectId.find((p) => String(p.ProjectId) === String(data.ProjectID))
    ?.ProjectName || ""
                              }
                            : null
                        }
                        // 23-10
                        onChange={(selectedOption) => {
                          handleProjectSelect(selectedOption?.value || "");
                          setErrors((prev) => ({ ...prev, ProjectID: "" }));
                        }}
                        options={[
                          ...new Map(
                            projectId.map((item) => [item.ProjectId, item]),
                          ).values(),
                        ].map((val) => ({
                          value: val.ProjectId,
                          label: val.ProjectName,
                        }))}
                        isSearchable={true}
                        //9/10
                        isClearable={true}
                        styles={{
                          control: (base) => ({
                            ...base,
                            minHeight: "38px",
                            height: "38px",
                            fontSize:"14px"
                          }),
                          valueContainer: (base) => ({
                            ...base,
                            height: "33px",
                            padding: "0 8px",
                          }),
                          input: (base) => ({ ...base, margin: 0, padding: 0 }),
                          indicatorsContainer: (base) => ({
                            ...base,
                            height: "33px",
                          }),
                        }}
                      />
 {/* 23-10 */}
   {errors.ProjectID && <p className="field-error">{errors.ProjectID}</p>}

                    </div>
                  </div>
                </div>
                {data.Scheme === "Budget" && (
                  <div className="col-12 elements">
                    <div className="row">
                      <div className="col-3">
                        <label style={{ fontWeight: "700" ,fontSize:"14px"}}>Head Name</label>
                      </div>
                      <div className="col-9">
                        <input
                          type="text"
                          value={data.BudgetHeadName}
                          readOnly
                          style={{ height: "38px" }}
                        />
                      </div>
                    </div>
                  </div>
                )}

                <div className="col-12 elements">
                  <div className="row">
                    <div className="col-3  ">
                      <label style={{ fontWeight: "700" ,fontSize:"14px"}}>
                        Work Order UID
                      </label>
                    </div>
                    <div className="col-9">
                      {/* <select name="WorkUID" value={data.WorkUID} id="" className='py-2' onChange={(e) => { HandleChangeData(e); handleWorkOrderSelect(e.target.value) }}>
                                                <option>Choose Work Order No</option>
                                                {filterdWorkID &&
                                                    [...new Map(filterdWorkID.map(item => [item.workOrderID, item])).values()]
                                                        .map((val, index) => (
                                                            <option key={index} value={val.workNo}>
                                                                {val.workNo}
                                                            </option>
                                                        ))
                                                }
                                            </select> */}
                      <Select
                        options={[
                          ...new Map(
                            workOrdersByProject.map((work) => [
                              work.workNo,
                              work,
                            ]),
                          ).values(),
                        ].map((work) => ({
                          value: work.workNo,
                          label: `${work.workNo} - ${work.WorkName}`,
                        }))}
                        value={
                          data.WorkUID
                            ? {
                                value: data.WorkUID,
                                label: (() => {
                                  const work = workOrdersByProject.find(
                                    (item) => item.workNo === data.WorkUID,
                                  );
                                  return work
                                    ? `${work.workNo} - ${work.WorkName}`
                                    : data.WorkUID;
                                })(),
                              }
                            : null
                        }
                        onChange={(selected) =>
                          handleWorkOrderSelect(selected ? selected.value : "")
                        }
                        placeholder="Choose Work Order"
                        isSearchable
                        isClearable
                        isDisabled={!data.ProjectID}
                        // styles={{
                        //   control: (base) => ({
                        //     ...base,
                        //     // minHeight: "33px",
                        //     height:"16px",
                        //     borderRadius: "5px",
                        //     fontSize: "13px",
                        //   }),
                        // }}
                         styles={{
    control: (base) => ({
      ...base,
      minHeight: "38px",
      height: "38px",
      borderRadius: "4px",
      fontSize: "12px",
      boxSizing: "border-box",
    }),
 
    valueContainer: (base) => ({
      ...base,
      height: "38px",
      padding: "0 8px",
    }),
 
    input: (base) => ({
      ...base,
      margin: 0,
      padding: 0,
    }),
 
    indicatorsContainer: (base) => ({
      ...base,
      height: "38px",
    }),
 
    clearIndicator: (base) => ({
      ...base,
      padding: "5px",
    }),
 
    dropdownIndicator: (base) => ({
      ...base,
      padding: "5px",
    }),
  }}
 
                      />
                    </div>
                  </div>
                </div>

                {/* <div className="col-12 my-3">
                                    <div className="row">

                                        <div className="col-12">
                                            <div className="tableContainer m-auto">
                                                <table>
                                                    <thead>
                                                        <tr>
                                                            <th style={{ width: "10%", textAlign: "start" }}>Year</th>
                                                            <th style={{ width: "25%", textAlign: "start" }}>Budget Head</th>
                                                            <th style={{ width: "20%", textAlign: "start" }}>Amount</th>

                                                            <th style={{ width: "20%", textAlign: "start" }}>Date</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {
                                                            tableData.length ?
                                                                tableData.map((val, index) => {
                                                                    return (
                                                                        <tr key={index}>
                                                                            <td style={{ textAlign: "start" }}>{val.FinancialYear}</td>
                                                                            {/* <td style={{ textAlign: "start" }}>{val.CRC}/{val.HeadName}</td> 
                                                                            <td style={{ textAlign: "start" }}>
                                                                                {val.CRC || ""}{val.CRC && (val.HeadName || val.BudgetHead) ? "/" : ""}{val.HeadName || val.BudgetHead || ""}
                                                                            </td>

                                                                            <td style={{ textAlign: "start" }}>{TotalEstimateAmount || 0}</td>

                                                                            <td style={{ textAlign: "start" }}>{new Date(val.Date).toLocaleString()}</td>
                                                                        </tr>

                                                                    )
                                                                }) : (
                                                                    <tr><td colSpan="4">No data found</td></tr>
                                                                )
                                                        }
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>

                                    </div>
                                </div> */}

                <div className="col-12 my-3">
                  <div className="row">
                    <div className="col-12">
                      <div className="tableContainer m-auto">
                        <table>
                          <thead>
                            <tr
                              style={{
                                backgroundColor: "#eef5fd",
                                color: "black",
                                border: "1px solid black",
                              }}
                            >
                              <th style={{ width: "15%", textAlign: "start" }}>
                                Vendor Name
                              </th>
                              <th style={{ width: "15%", textAlign: "start" }}>
                                Work Approve Amount
                              </th>
                              <th style={{ width: "20%", textAlign: "start" }}>
                                Remaing Amount
                              </th>
                              <th style={{ width: "15%", textAlign: "start" }}>
                                Bank Name
                              </th>
                              <th style={{ width: "15%", textAlign: "start" }}>
                                Bank Account Number
                              </th>
                              <th style={{ width: "10%", textAlign: "start" }}>
                                Bank IFSC
                              </th>
                              <th style={{ width: "15%", textAlign: "start" }}>
                                Bank Branck Name
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {tableData?.length > 0 ? (
                              tableData?.map((val, index) => {
                                return (
                                  <tr key={index}>
                                    <td style={{ textAlign: "center" }}>
                                      {val?.ContractorName}
                                    </td>
                                    <td style={{ textAlign: "center" }}>
                                      {/* {val.ApprovedWorkAmount} */}
                                      {Number(
                                        val.ApprovedWorkAmount || 0,
                                      ).toLocaleString("en-IN")}
                                    </td>
                                    <td style={{ textAlign: "center" }}>
                                      {/* {val.RemainingAmount || 0} */}
                                      {Number(
                                        val.RemainingAmount || 0,
                                      ).toLocaleString("en-IN")}
                                    </td>
                                    <td style={{ textAlign: "center" }}>
                                      {val.BANK_NAME}
                                    </td>
                                    <td style={{ textAlign: "center" }}>
                                      {val.Account_Number}
                                    </td>
                                    <td style={{ textAlign: "center" }}>
                                      {val.IFSC_CODE}
                                    </td>
                                    <td style={{ textAlign: "center" }}>
                                      {val.BranchName}
                                    </td>
                                  </tr>
                                );
                              })
                            ) : (
                              <tr>
                                <td colSpan="7"> No Data Found </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-12 elements">
                  <div className="row">
                    <div className="col-3">
                      <label style={{ fontWeight: "700" ,fontSize:"14px"}}>
                        Physical Progress{" "}
                        <span style={{ color: "red" }}>*</span>
                      </label>
                    </div>
                    <div className="col-9">
                      <input
                        type="text"
                        value={data.PhysicalProgress}
                        readOnly
                        required
                        style={{ height: "38px" }}
                      />
                    </div>
                  </div>
                </div>

                <div className="col-12 elements">
                  <div className="row">
                    <div className="col-3  ">
                      <label style={{fontSize: "14px",fontWeight:"700",}}>Total Bill Amount</label>
                    </div>
                    <div className="col-9" >
                      <input
                        type="text"
                        placeholder={`Enter Amount`}
                        name="BillAmount"
                        // value={data.BillAmount}
                        value={
                          data.BillAmount !== "" && data.BillAmount !== null
                            ? Number(data.BillAmount).toLocaleString("en-IN")
                            : ""
                        }
                        // onChange={HandleChangeData}
                        // 23-10
                        onChange={(e) => {
                          const rawValue = e.target.value.replace(/,/g, "");
                          HandleChangeData({
                            target: { name: "BillAmount", value: rawValue },
                          });
                          if (rawValue && Number(rawValue) > 0) {
                            setErrors((prev) => ({ ...prev, BillAmount: "" }));
                          }
                        }}
                      />
                      {/* 23-10 */}
                       {errors.BillAmount && <p className="field-error">{errors.BillAmount}</p>}
                    </div>
                  </div>
                </div>

                {/* <div className="col-12 elements">
                                <div className="row">
                                    <div className="col-3  ">
                                        <label>Gross Amount</label>
                                    </div>
                                    <div className="col-4">
                                        <input type="number"
                                            placeholder='Enter Gross Amount'
                                            value={
                                                GrossAmount.toFixed(2)
                                            } disabled />
                                    </div>
                                </div>
                            </div> */}

                <div className="col-12 elements">
                  {/* <div className="row">
                                    <div className="col-3  ">
                                        <label>Net Payable Amount</label>
                                    </div>
                                    <div className="col-4">
                                        <input type="number" placeholder='Enter Net payuable Amount' value={netPayableAmount} disabled />
                                    </div>
                                </div> */}
                </div>

                <div className="col-12 elements">
                  <div className="row">
                    <div className="col-3 ">
                      <label style={{fontSize: "14px",fontWeight:"700",}}> RA Bill Number</label>
                    </div>
                    {/* <div className="col-9" style={{ height: '33px' }}>
                                            <input type="text" placeholder='Enter Bill Number' name='RABillAmount' value={data.RABillAmount} onChange={HandleChangeData} />
                                        </div> */}

                    {/* <div className="col-3 my-auto">
                                        <p className='fw-bold my-auto'>Full and Final Bill</p>
                                    </div> */}
                    {/* <div className="col-3 my-auto">
                      <select
                        name="RABillAmount"
                        value={data.RABillAmount}
                        onChange={HandleChangeData}
                      >
                        <option value="">Choose Bill Number</option>
                        <option value="First Bill">First Bill</option>
                        <option value="Second Bill">Second Bill</option>
                        <option value="Third Bill">Third Bill</option>
                        <option value="Final Bill">Final</option>
                      </select>
                    </div> */}
                    <div className="col-9 ">
                      <Select
                        options={[
                          { value: "First Bill", label: "First Bill" },
                          { value: "Second Bill", label: "Second Bill" },
                          { value: "Third Bill", label: "Third Bill" },
                          { value: "Final Bill", label: "Final" },
                        ]}
                        value={
                          data.RABillAmount
                            ? {
                                value: data.RABillAmount,
                                label:
                                  data.RABillAmount === "Final Bill"
                                    ? "Final"
                                    : data.RABillAmount,
                              }
                            : null
                        }
                        // 23-10
                       onChange={(selected) => {
                          HandleChangeData({
                            target: {
                              name: "RABillAmount",
                              value: selected ? selected.value : "",
                            },
                          });
                          if (selected) setErrors((prev) => ({ ...prev, RABillAmount: "" }));
                        }}
                        placeholder="Choose Bill Number"
                        isSearchable
                        isClearable
                        // styles={{
                        //   control: (base) => ({
                        //     ...base,
                        //     minHeight: "30px",
                        //     borderRadius: "5px",
                        //     fontSize: "13px",
                        //   }),
                        // }}
                         styles={{
  control: (base) => ({
    ...base,
    minHeight: "38px",
    height: "38px",
    borderRadius: "4px",
    fontSize: "12px",
    boxSizing: "border-box",
  }),
 
  valueContainer: (base) => ({
    ...base,
    height: "38px",
    padding: "0 8px",
  }),
 
  input: (base) => ({
    ...base,
    margin: 0,
    padding: 0,
  }),
 
  indicatorsContainer: (base) => ({
    ...base,
    height: "38px",
  }),
 
  clearIndicator: (base) => ({
    ...base,
    padding: "5px",
  }),
 
  dropdownIndicator: (base) => ({
    ...base,
    padding: "5px",
  }),
}}
 
                      />
                      {/* 23-10 */}
                                            {errors.RABillAmount && <p className="field-error">{errors.RABillAmount}</p>}

                    </div>
                  </div>
                </div>

                <div className="col-12 elements">
                  <div className="row">
                    <div className="col-3  ">
                      <label style={{fontSize: "14px",fontWeight:"700",}}>Remark</label>
                    </div>
                    <div className="col-9" >
                      <input
                        type="text"
                        placeholder="Enter Remark"
                        name="Remark"
                        value={data.Remark}
                        // onChange={HandleChangeData}
                        // 23-10
                         onChange={(e) => {
                          HandleChangeData(e);
                          if (e.target.value.trim()) {
                            setErrors((prev) => ({ ...prev, Remark: "" }));
                          }
                        }}
                      />
                      {/* 23-10 */}
                                              {errors.Remark && <p className="field-error">{errors.Remark}</p>}

                    </div>
                  </div>
                </div>

                {/* <div className="col-12 elements">
                  <div className="row">
                    <div className="col-3  ">
                      <label style={{fontSize: "14px",fontWeight:"700",}}>
                        Upload Bill Copy<span style={{ color: "red" }}>*</span>
                      </label>
                    </div>
                    <div className="col-9" style={{ height: "38px" }}>
                      <input
                        type="file"
                        name="BillCopy"
                        required
                        onChange={(e) => {
                          const file = e.target.files[0];
                          if (!file) {
                            setBillCopy(null);
                            return;
                          }
                          setBillCopy(file);
                        }}
                        className="form-control"
                        id="BillCopy"
                      />
                    </div>
                  </div>
                </div> */}

{/* 23-09 coopy fetch */}

    <div className="col-12 elements">
                  <div className="row">
                    <div className="col-3">
                      <label style={{ fontSize: "15px" }}>
                        Upload Bill Copy<span style={{ color: "red" }}>*</span>
                      </label>
                    </div>
                    <div className="col-9">
                      <input
                        type="file"
                        name="BillCopy"
                        required={!isEdit}
                        // onChange={(e) => {
                        //   const file = e.target.files[0];
                        //   if (!file) {
                        //     setBillCopy(null);
                        //     return;
                        //   }
                        //   setBillCopy(file);
                        // }}
                        // 23-10
                         onChange={(e) => {
                          const file = e.target.files[0];
                          if (!file) {
                            setBillCopy(null);
                            return;
                          }
                          setBillCopy(file);
                          setErrors((prev) => ({ ...prev, BillCopy: "" }));
                        }}
                        className="form-control"
                        id="BillCopy"
                        style={{ height: "38px" }}
                      />
                      {/* 23-10 */}
                                            {errors.BillCopy && <p className="field-error">{errors.BillCopy}</p>}

                    </div>
                  </div>
 
                  {isEdit && data.UploadBillCopy && !BillCopy ? (
                    <div className="row">
                      <div className="col-3"></div>
                      <div className="col-9" style={{ fontSize: "13px", marginTop: "6px" }}>
                        Current file:{" "}
                       
                       <a
  href={
    typeof data.UploadBillCopy === "string"
      ? apiurl + "/BillCopyDocsImages/" + data.UploadBillCopy
      : "#"
  }
  target="_blank"
  rel="noreferrer"
>
                          {String(data.UploadBillCopy).split("/").pop()}
                        </a>
                      </div>
                    </div>
                  ) : null}
                </div>
 



                <div className="col-12 elements ">
                  <div className="col-12">
                    <div
                      className="row"
                      style={{
                        background: "#cbe1edff",
                        border: "2px solid #e3eff6",
                      }}
                    >
                      <div className="col-4 part1 py-2">
                        <div className="row">
                          <div className="col-5 my-auto">
                            <p className="my-auto">Net Bill Amount:</p>
                          </div>
                          <div className="col-6 my-auto">
                            <p className="my-auto">
                              {/* <b>{data.BillAmount}</b> */}
                              <b>
                                {" "}
                                ₹{" "}
                                {Number(data.BillAmount || 0).toLocaleString(
                                  "en-IN",
                                )}
                              </b>
                            </p>
                          </div>
                        </div>
                      </div>

                      <div className="col-4 part1 py-2">
                        <div className="row">
                          <div className="col-7 my-auto">
                            <p className="my-auto">Net Payable Amount : </p>
                          </div>
                          <div className="col-5 my-auto">
                            <p className="my-auto">
                              {/* <b>{netPayableAmount || 0}</b> */}
                              <b>
                                {" "}
                                ₹{" "}
                                {Number(netPayableAmount || 0).toLocaleString(
                                  "en-IN",
                                )}
                              </b>
                            </p>
                          </div>
                        </div>
                      </div>

                      <div className="col-4 part1 py-2">
                        <div className="row">
                          <div className="col-8 my-auto">
                            <p className="my-auto">Total Deduction Amount : </p>
                          </div>
                          <div className="col-4 my-auto">
                            <p className="my-auto">
                              <b>
                                {" "}
                                {Number(totalDeductionAmount || 0).toFixed(2)}
                              </b>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* <div className="col-12 my-3">
                                <div className="row">

                                    <div className="col-12">'
                                        <div className="tableContainer m-auto">
                                            <table>
                                                <thead>
                                                    <tr>
                                                        <th style={{ width: "5%", textAlign: "start" }}>Sr.No</th>
                                                        <th style={{ width: "15%", textAlign: "start" }}>Deduction Type</th>
                                                        <th style={{ width: "15%", textAlign: "start" }}>Amount</th>
                                                        <th style={{ width: "25%", textAlign: "start" }}>Account Name</th>
                                                        <th style={{ width: "20%", textAlign: "start" }}>Account Number</th>
                                                        <th style={{ width: "20%", textAlign: "start" }}>IFSC Code</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        bankData.length ?
                                                            bankData.filter(val =>
                                                                val.UseFor === "SGST" ||
                                                                val.UseFor === "CGST" ||
                                                                val.UseFor === "Security Deposite"
                                                            ).map((val, index) => {
                                                                const key = val.UseFor.replace(/\s+/g, ""); // e.g., SGST
                                                                return (
                                                                    <tr key={index}>
                                                                        <td style={{ textAlign: "start" }}>{index + 1}</td>
                                                                        <td style={{ textAlign: "start" }}>{val.UseFor}</td>
                                                                        <td style={{ textAlign: "start" }}><input type="number"
                                                                            className="form-control"
                                                                            style={{ border: '1px solid darkgray', borderBottom: '1px solid #857979' }}
                                                                            name={key} // Remove spaces for consistent keys
                                                                            value={data?.[key] || "0"}
                                                                            placeholder="Enter"
                                                                            onChange={handleInputChange}
                                                                            required /></td>
                                                                        <td style={{ textAlign: "start" }}>{val.AccountHodlerName}</td>
                                                                        <td style={{ textAlign: "start" }}>{val.Account_Number}</td>
                                                                        <td style={{ textAlign: "start" }}>{val.IFSC_CODE}</td>
                                                                    </tr>

                                                                )
                                                            }) : (
                                                                <tr><td colSpan="6">No data found</td></tr>
                                                            )
                                                    }
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>

                                </div>
                            </div> */}

                <div className="col-12 elements my-4">
                  <div className="row">
                    <div className="col-5 ">
                      <label style={{fontSize: "14px",fontWeight:"700",}}>Do You Want to Add Deduction?</label>
                    </div>

                    <div className="col-5 d-flex align-items-center gap-3">
                      <div>
                        <input
                          type="radio"
                          id="deductionYes"
                          name="type"
                          value="true"
                          checked={data.type === "true"}
                          onChange={(e) => HandleChangeData(e)}
                        />
                        <label htmlFor="deductionYes" className="ms-1">
                          Yes
                        </label>
                      </div>

                      <div>
                        <input
                          type="radio"
                          id="deductionNo"
                          name="type"
                          value="false"
                          checked={data.type === "false"}
                          onChange={(e) => HandleChangeData(e)}
                        />
                        <label htmlFor="deductionNo" className="ms-1">
                          No
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
                {data && data.type == "true" && (
                  <div
                    className="deduction-section my-3"
                    style={{
                      width: "100%",
                      padding: "18px 20px 20px",
                      background: "#f8fafc",
                      border: "1px solid #e1e7ef",
                      borderRadius: "10px",
                      boxSizing: "border-box",
                    }}
                  >
                    {/* ================= DEDUCTION FORM ================= */}
                    <div className="row g-3">
                      {/* Favouring */}
                      <div className="col-xl-3 col-lg-3 col-md-6 col-sm-12">
                        <label
                          className="form-label fw-bold mb-1"
                          style={{
                            fontSize: "14px",fontWeight:"700",
                            color: "#333",
                          }}
                        >
                          Favouring
                        </label>

                        <Select
                          options={
                            tableData
                              ?.filter((val) => val.ContractorName)
                              .map((val) => ({
                                value: val.ContractorName,
                                label: val.ContractorName,
                              })) || []
                          }
                          value={
                            selectedFavouring
                              ? {
                                  value: selectedFavouring,
                                  label: selectedFavouring,
                                }
                              : null
                          }
                          onChange={(selected) =>
                            setSelectedFavouring(selected ? selected.value : "")
                          }
                          placeholder="Choose Favouring"
                          isSearchable
                          isClearable
                          styles={{
                            control: (base, state) => ({
                              ...base,
                              minHeight: "38px",
                              height: "38px",
                              borderRadius: "6px",
                              fontSize: "12px",
                              borderColor: state.isFocused
                                ? "#0d6efd"
                                : "#ced4da",
                              boxShadow: state.isFocused
                                ? "0 0 0 2px rgba(13,110,253,0.10)"
                                : "none",
                            }),

                            valueContainer: (base) => ({
                              ...base,
                              height: "38px",
                              padding: "0 10px",
                            }),

                            indicatorsContainer: (base) => ({
                              ...base,
                              height: "38px",
                            }),

                            input: (base) => ({
                              ...base,
                              fontSize: "12px",
                            }),

                            placeholder: (base) => ({
                              ...base,
                              fontSize: "12px",
                              color: "#6c757d",
                            }),

                            singleValue: (base) => ({
                              ...base,
                              fontSize: "12px",
                            }),

                            option: (base, state) => ({
                              ...base,
                              fontSize: "12px",
                              backgroundColor: state.isSelected
                                ? "#0d6efd"
                                : state.isFocused
                                  ? "#eaf3ff"
                                  : "#fff",
                              color: state.isSelected ? "#fff" : "#333",
                            }),
                          }}
                        />
                      </div>

                      {/* Deduction Type */}
                      <div className="col-xl-3 col-lg-3 col-md-6 col-sm-12">
                        <label
                          className="form-label fw-bold mb-1"
                          style={{
                            fontSize: "14px",fontWeight:"700",
                            color: "#333",
                          }}
                        >
                          Deduction Type
                        </label>

                        <Select
                          options={
                            fetchDeductionData?.map((val) => ({
                              value: val.DeductionID,
                              label: val.UseFor,
                            })) || []
                          }
                          value={
                            selectedDeductionID
                              ? {
                                  value: selectedDeductionID,
                                  label: selectedDeductionName,
                                }
                              : null
                          }
                          onChange={(selected) => {
                            const id = selected ? selected.value : "";

                            const selectedDeduction = fetchDeductionData.find(
                              (item) => item.DeductionID == id,
                            );

                            setSelectedDeductionID(id);

                            setSelectedDeductionName(
                              selectedDeduction?.UseFor || "",
                            );

                           
  const isEditingExisting =
    editIndexOF !== null && deductionList[editIndexOF];

  if (isEditingExisting) {
    // just change the type of the row being edited
    const duplicate = deductionList.some(
      (d, i) => i !== editIndexOF && String(d.DeductionID) === String(id),
    );
    if (duplicate) {
      alert("Deduction with this type already exists.");
      return;
    }
    setEditIndex((prev) => ({
      ...prev,
      DeductionID: id,
      DeductionName: selectedDeduction?.UseFor || "",
    }));
  } else {
    deductionOperation({
      DeductionID: id,
      DeductionName: selectedDeduction?.UseFor || "",
    });
  }
}}
                          placeholder="Choose Deduction Type"
                          isSearchable
                          isClearable
                          styles={{
                            control: (base, state) => ({
                              ...base,
                              minHeight: "38px",
                              height: "38px",
                              borderRadius: "6px",
                              fontSize: "12px",
                              borderColor: state.isFocused
                                ? "#0d6efd"
                                : "#ced4da",
                              boxShadow: state.isFocused
                                ? "0 0 0 2px rgba(13,110,253,0.10)"
                                : "none",
                                whiteSpace:"nowrap"
                            }),

                            valueContainer: (base) => ({
                              ...base,
                              height: "38px",
                              padding: "0 10px",
                            }),

                            indicatorsContainer: (base) => ({
                              ...base,
                              height: "38px",
                            }),

                            input: (base) => ({
                              ...base,
                              fontSize: "12px",
                            }),

                            placeholder: (base) => ({
                              ...base,
                              fontSize: "12px",
                              color: "#6c757d",
                            }),

                            singleValue: (base) => ({
                              ...base,
                              fontSize: "12px",
                            }),

                            option: (base, state) => ({
                              ...base,
                              fontSize: "12px",
                              backgroundColor: state.isSelected
                                ? "#0d6efd"
                                : state.isFocused
                                  ? "#eaf3ff"
                                  : "#fff",
                              color: state.isSelected ? "#fff" : "#333",
                            }),
                          }}
                        />
                      </div>

                      {/* Percentage 29-09 */} 
                      <div className="col-xl-3 col-lg-3 col-md-6 col-sm-12" >
                        <label
                          className="form-label fw-bold mb-1"
                          style={{
                            fontSize:  "14px",fontWeight:"700",
                            color: "#333",
                          }}
                        >
                          Percentage
                        </label>

                        <input
                          type="text"
                          className="form-control form-control-sm"
                          // value={
                          //   editIndex?.DeductionPercent <= 0
                          //     ? 0
                          //     : editIndex?.DeductionPercent
                          // } 
                          
                          // 26-09

  //                          value={
  //   !editIndex || editIndex?.DeductionPercent <= 0
  //     ? 0
  //     : editIndex?.DeductionPercent
  // }
  // 29-09
   value={
      !editIndex || editIndex?.DeductionPercent <= 0
        ? ""
        : `${Number(editIndex.DeductionPercent).toFixed(2)}%`
    }
 
                          disabled
                          style={{
                           height: "38px",
    fontSize: "13px",
    borderRadius: "6px",
    backgroundColor: "#e9ecef",
    color: "#495057",
    fontWeight: "500",
    paddingRight: "30px",
    justifyContent:'center'
  }}
//  23-09 percent ui
                       
                       />

                        
                      </div>

                      {/* Amount */}
                      <div className="col-xl-3 col-lg-3 col-md-6 col-sm-12">
                        <label
                          className="form-label fw-bold mb-1"
                          style={{
                            fontSize: "14px",fontWeight:"700",
                            color: "#333",
                          }}
                        >
                          Amount
                        </label>

                        <input
                          type="number"
                          className="form-control form-control-sm"
                          // value={
                          //   editIndex?.DeductionAmount < 0
                          //     ? 0
                          //     : editIndex?.DeductionAmount
                          // }

                          // 26-09
                          value={
                            !editIndex || editIndex?.DeductionAmount < 0
                              ? 0
                              : editIndex?.DeductionAmount
                          }
                          onChange={(e) =>
                            setEditIndex({
                              ...editIndex,
                              DeductionAmount: e.target.value,
                            })
                          }
                          required
                          style={{
                            height: "38px",
                            fontSize: "13px",
                            borderRadius: "6px",
                          }}
                        />
                      </div>
                    </div>

                    {/* ================= ACTION BUTTONS ================= */}
                    <div className="dg-deduction-actions" >
                      {/* Add Deduction */}
                     {/* 30-10 */}
<button type="button" className="dg-btn dg-btn-add" onClick={(e) => handelchangeTablre(e)}>
  <PlusCircle />{" "}
  {editIndexOF !== null && deductionList[editIndexOF]
    ? "Update Deduction"
    : "Add Deduction"}
</button>
                      {/* Cancel */}
                     <button
    type="button"
    className="dg-btn dg-btn-outline"
    onClick={() => {
      setEditIndex(null);
      setEditIndexOF(null);
      setSelectedFavouring("");
      setSelectedDeductionID("");
      setSelectedDeductionName("");
      alert("Deduction entry cancelled!");
    }}
  >
    <XCircle /> Cancel
  </button>
                    </div>
                  </div>
                )}

                {deductionList.length > 0 && (
                  <div className="col-12 my-3">
                    <div className="row">
                      <div className="col-12">
                        <div className="tableContainer m-auto">
                          <table>
                            <thead>
                              <tr>
                                <th style={{ width: "5%", textAlign: "start" }}>
                                  Sr.No
                                </th>
                                <th style={{ width: "5%", textAlign: "start" }}>
                                  Favouring
                                </th>
                                <th style={{ width: "5%", textAlign: "start" }}>
                                  Deduction Name
                                </th>
                                <th
                                  style={{ width: "15%", textAlign: "start" }}
                                >
                                  Deduction Percentage
                                </th>
                                <th
                                  style={{ width: "15%", textAlign: "start" }}
                                >
                                  Deduction Amount
                                </th>
                                <th
                                  style={{ width: "10%", textAlign: "start" }}
                                >
                                  Action
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {deductionList.length ? (
                                deductionList.map((val, index) => {
                                  return (
                                    <tr key={index}>
                                      <td style={{ textAlign: "start" }}>
                                        {index + 1}
                                      </td>
                                      <td style={{ textAlign: "start" }}>
                                        {data.ContractorName}
                                      </td>
                                      <td style={{ textAlign: "start" }}>
                                        {val.DeductionName}
                                      </td>
                                      <td style={{ textAlign: "start" }}>
                                        {/* {val.DeductionPercent} % */}
                                        {/* 29-09 */}
                                          {val.DeductionPercent > 0 ? `${val.DeductionPercent}%` : ""}
 
                                      </td>
                                      {/* <td style={{ textAlign: "start" }}> */}
                                        {/* {Number(
                                          val.DeductionAmount || 0,
                                        ).toFixed(2)} */}
                                        <td style={{ textAlign: "start" }}>
                                          {Math.round(
                                            Number(val.DeductionAmount || 0),
                                          )}
                                        </td>
                                      {/* </td> */}
                                       {/* 28-10 */}
                                      <td className="dg-actions-cell">
  <button type="button" className="dg-mini dg-edit" onClick={(e) => handleEdit(e, index)}>
    Edit
  </button>
  <button type="button" className="dg-mini dg-delete"
          onClick={(e) => handleDeleteDeduction(e, val.DeductionID)}>
    Delete
  </button>
</td>
                                    </tr>
                                  );
                                })
                              ) : (
                                <tr style={{ backgroundColor: "blue" }}>
                                  <td colSpan="7">No data found</td>
                                </tr>
                              )}
                              {deductionList.length > 0 && (
                                <tr>
                                  <td
                                    style={{ textAlign: "center" }}
                                    colSpan="3"
                                  >
                                    <b>Total</b>
                                  </td>
                                  <td style={{ textAlign: "start" }}>
                                    {/* <b>{totalDeductionPercent} %</b> */}
                                   {/* 28-10 */}
  <b>{totalDeductionPercent > 0 ? `${Number(totalDeductionPercent).toFixed(2)}%` : ""}</b>
 
                                  </td>
                                  <td style={{ textAlign: "start" }}>
                                    <b>
                                      {" "}
                                      {/* {Number(
                                        totalDeductionAmount || 0,
                                      ).toFixed(2)} */}
                                      <b>{Math.round(totalDeductionAmount)}</b>
                                    </b>
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                <div className="col-12 ms-auto my-5">
                  <div className="row">
                    <div className="col-5"></div>
                    <div className="col-12">
                      <div  className="dg-footer-btns"   >
                        
                        {/* <button
                          type="submit"
                          disabled={loading}
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            borderRadius: "20px",
                            width: "120px",
                            height: "40px",
                            backgroundColor: "#39b54a",
                            border: "none",
                            fontSize: "16px",
                            color: "#ffffff",
                            fontWeight: "700",
                          }}
                          onClick={handleSubmit}
                        >
                          <img
                            src={submit}
                            style={{
                              marginRight: "10px",
                              width: "1.2rem",
                              paddingBottom: "3px",
                              fontSize: "15px",
                            }}
                          />
                          {loading
                            ? isEdit
                              ? "Updating..."
                              : "Submitting..."
                            : isEdit
                              ? "Update"
                              : "Save"}
                        </button> */}
                        {/* 21-09 */}
                        <button
  type="submit"
  disabled={loading}
   onClick={handleSubmit}
    className="dg-btn dg-btn-save" //28-10
    >
  {loading ? (
    <>
      <span className="dg-spin" />

      {isEdit ? "Updating..." : "Submitting..."}
    </>
  ) : (
    <>
      
<CheckCircle />
      {isEdit ? "Update" : "Save"}
    </>
  )}
</button>
                        <button
                          type="button"
                         className="dg-btn dg-btn-cancel"
                        >
                          <XCircle bg="transparent" /> 
                          Cancel
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DemandGeneration;
